import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

const CommonPopup = ({
                       buttonOpenPopupLabel,
                       buttonLabelConfirm = 'אישור',
                       buttonLabelCancel = 'ביטול',
                       header,
                       content = () => {
                       },
                       onConfirm,
                       icon,
                       buttonOpenPopupClassName = '',
                       disabled,
                       size = 'm',
                       disabledConfirmButton = false,
                       buttonTooltip = '',
                       handleOnShowModal = () => {
                       },
                       handleOnHideModal = () => {
                       },
                     }) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);

  return (
    <>
      <Button
        className={buttonOpenPopupClassName}
        onClick={() => {
          handleOnShowModal();
          handleShowModal();
        }}
        disabled={disabled}
        title={buttonTooltip}
      >
        {buttonOpenPopupLabel}
        {icon}
      </Button>
      <Modal
        show={show}
        onHide={handleCloseModal}
        size={size}
      >
        <Modal.Body>
          <h3 className="card-title font-weight-bold text-dark text-center">
            {header}
          </h3>
          {show && <div>{content()}</div>}
          <div className="d-flex justify-content-center">
            <Button
              className="btn btn-secondary btn-sm col-3 mx-3"
              onClick={() => {
                handleOnHideModal();
                handleCloseModal();
              }}
            >
              {buttonLabelCancel}
            </Button>
            {Boolean(onConfirm) && (
              <Button
                className="btn btn-primary btn-sm col-3 mx-3 custom-send-button"
                onClick={() => {
                  onConfirm();
                  handleCloseModal();
                }}
                disabled={disabledConfirmButton}
              >
                {buttonLabelConfirm}
              </Button>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

CommonPopup.propTypes = {
  buttonOpenPopupLabel: PropTypes.node,
  header: PropTypes.node,
  content: PropTypes.func,
  onConfirm: PropTypes.func,
  disabled: PropTypes.bool,
  disabledConfirmButton: PropTypes.bool,
  buttonTooltip: PropTypes.node,
  buttonLabelConfirm: PropTypes.string,
  buttonLabelCancel: PropTypes.string,
  buttonOpenPopupClassName: PropTypes.string,
  size: PropTypes.string,
  handleOnShowModal: PropTypes.func,
  handleOnHideModal: PropTypes.func,
};

export default CommonPopup;
